import * as S from './Tag.styled'

const Tag = ({ tag, size, ...props }) => {
  return <S.Tag size={size} {...props}>{tag}</S.Tag>
}

export default Tag
